/**
 * 对象容器
 * 将公用对象都挂载到此容器中，方便调用
 */
export default {
	lastModel: 1,
	beforeCropModel: '',
	noMember(){
        $('.banner_box>#drag-zone').removeClass('active');
        $('.banner_box>.info_log').show();
        $('.header .right>.login>span').show()
        $('.photo_upgrade').removeClass('active');

        $('.login_box').hide();
        $('.login_btn>a').show();
        $('.photo_toggle_box>div span').removeClass('no');
        setCookie("user","",-1)
        user="";
    },
    LoginSuccess(){
        user=JSON.parse(getCookie('user'))
        if(user){
            $.post(
                post_url+"product/trial",
                {
                    e_id:user.e_id,
                    t_id:user.t_id,
                    token:user.token,
                    p_id:this.product_id
                },
                function(data){
                }
            )
        }else{
            this.noMember();
        }
    },
    visitor2Login:'',
    downJson:'',
    manage(operation,data){
        // _gaq.push(['_trackEvent','Watermark Remover',operation,String(data)]);
    },
    brush_model:[],
    brush_size:[],
    subscriptions:null,
    original:0,
    token:'',
    // 0首次进入
    first:0,
    product_id:197
}